"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapWithAssert = exports.hasItems = void 0;
const hasItems = (items) => !!items && items.length > 0;
exports.hasItems = hasItems;
const mapWithAssert = (array, callback) => array.map(callback);
exports.mapWithAssert = mapWithAssert;
